<template>
    <div class="not-found">
        <div class="not-found__img">
            <img src="@studio/assets/img/img_empty_page_def.svg">
        </div>
        <dl class="not-found__info">
            <dt class="not-found__title">
                抱歉，出了一些问题，页面不见了。
            </dt>
            <dd class="not-found__detail">
                可能是以下原因：
            </dd>
            <dd class="not-found__detail">
                1、页面数据被删除。
            </dd>
            <dd class="not-found__detail">
                2、URL含有的ID不存在。
            </dd>
            <dd class="not-found__action">
                <hc-button class="not-found__go-home" type="primary" plain @click="goHome">
                    回到首页
                </hc-button>
            </dd>
        </dl>
    </div>
</template>
<script>

export default {
    methods: {
        goHome() {
            const consoleDomain = location.origin.replace('app.', '').replace(/studio|designer/i, 'app')
            location.replace(consoleDomain)
        },
    },
}
</script>
<style lang="less" scoped>
.not-found {
    padding-top: 180px;
    width: 480px;
    margin: 0 auto;
    &__img {
        width: 190px;
        height: 220px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    &__info {
        padding-top: 48px;
        color: #b9bfd3;
    }
    &__title {
        font-size: 20px;
        margin-bottom: 20px;
        color: #1f232f;
    }
    &__detail {
        font-size: 14px;
        line-height: 24px;
        color: #6D7283;
    }
    &__action {
        padding-top: 20px;
        width: 300px;
        font-size: 18px;
        color: #4c99fe;
    }
    &__go-home {
        float: left;
        cursor: pointer;
    }
}
</style>
